import { render } from "./StaggeredMediaContextGrid.vue?vue&type=template&id=285ddca0"
import script from "./StaggeredMediaContextGrid.vue?vue&type=script&lang=js"
export * from "./StaggeredMediaContextGrid.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/staggered-media-context-grid/StaggeredMediaContextGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "285ddca0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('285ddca0', __exports__)) {
    api.reload('285ddca0', __exports__)
  }
  
  module.hot.accept("./StaggeredMediaContextGrid.vue?vue&type=template&id=285ddca0", () => {
    api.rerender('285ddca0', render)
  })

}


export default __exports__